import React from 'react';
import "./Navbar.css";
import { HashLink } from 'react-router-hash-link';
import {FaBars,FaLinkedinIn,FaGithub,FaInstagram,FaTwitter} from 'react-icons/fa';

const Navbar = () => {

  document.onclick = (e)=>{
    if(e.target.id === 'navLinks' || e.target.id === 'showMenu'){
      return;
    }
    else{
      if(e.target.id !=='ham-btn'){
        if ( document.getElementById("showMenu").classList.contains('nav-menu-show')){
          document.getElementById("showMenu").classList.remove('nav-menu-show');
        }
      }
    }
  }

  const handleCopy=()=>{
    let emailCopy ='princepatel1576@gmail.com';
    navigator.clipboard.writeText(emailCopy);
    alert(`Email copied`);
  }

  const handleMenu=()=>{
    if ( document.getElementById("showMenu").classList.contains('nav-menu-show')){
      document.getElementById("showMenu").classList.remove('nav-menu-show');
    }
    else{
      document.getElementById("showMenu").classList.add('nav-menu-show');
    }
  }

  return (
    <>
      <header id='header'>
        <div className='logo'>
          <HashLink to='#home'>WELCOME</HashLink>
        </div>

        <nav className='nav-links'>
          <ul>
            <li className='links'><HashLink to='#about'><span>01.</span>About</HashLink></li>
            <li className='links'><HashLink to='#exp'><span>02.</span>Experience</HashLink></li>
            <li className='links'><HashLink to='#projects'><span>03.</span>Projects</HashLink></li>
            <li className='links'><HashLink to='#contact'><span>04.</span>Contact</HashLink></li>
            <li className='links link-btn'><a rel='noreferrer' href='https://drive.google.com/file/d/1p9uqfZMF0Jb5uIli9qcG25LFnH_K0tl1/view?usp=sharing' target='_blank'>Resume</a></li>
          </ul>
        </nav>

        {/* hamburger */}
         <button onClick={handleMenu} id='ham-btn' className='hamburger'>
           <FaBars id='ham-btn'/>
         </button>
          
      </header>

      {/* expand navbar */}
      <div className='navbar-expand' id='showMenu'>
        <nav className='menu' id='navMenu'>
          <ul id='navLinks'>
            <li className='links'><a href='#about'><span>01.</span>About</a></li>
            <li className='links'><a href='#exp'><span>02.</span>Experience</a></li>
            <li className='links'><a href='#projects'><span>03.</span>Projects</a></li>
            <li className='links'><a href='#contact'><span>04.</span>Contact</a></li>
            <li className='links link-btn'><a rel='noreferrer' href='https://drive.google.com/file/d/1p9uqfZMF0Jb5uIli9qcG25LFnH_K0tl1/view?usp=sharing' target='_blank'>Resume</a></li>
          </ul>
        </nav>
      </div>

      {/* floating social links */}
      <div className='side-social' >
        <ul>
          <li className='social-links'><a href='https://www.linkedin.com/in/prince-patel-bb6b32194/' target='_blank' rel='noreferrer'><FaLinkedinIn/></a></li>
          <li className='social-links'><a href='https://github.com/princepatel157' target='_blank' rel='noreferrer'><FaGithub/></a></li>
          <li className='social-links'><a href='https://www.instagram.com/prince.vikram.singh.patel/' target='_blank' rel='noreferrer'><FaInstagram/></a></li>
          <li className='social-links'><a href='https://twitter.com/princepatel1576'target='_blank' rel='noreferrer'><FaTwitter/></a></li>
        </ul>
      </div>
      <div className='right-side'>
        <ul>
          <li className='right-social-links'><a title='click to copy' onClick={handleCopy} id='emailLink' href='#email' value='hello'>princepatel1576@gmail.com</a></li>
        </ul>
      </div>
    </>
  )
}

export default Navbar